export const craftelementAPI = {
  /**
   * @return {Promise<EventGuide>}
   */
  async eventGuide() {
    const data = await axios.get('/api/event-guide?t=' + Date.now()).catch(() => ({ data: false }));

    return data.data;
  }
}